import Vue from "vue";
import Vuex from "vuex";
import Constant from "@/utils/constants";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    showLoading: false,
    imageId: "",
    imageIdBanner: "",
    imageIdDark: "",
    showLoadingBanner: false,
    imageNonPremuimIdBanner: "",
    imageNonPremuimId: ""
  },
  mutations: {
    setShowLoading(state, payload) {
      state.showLoading = payload;
    },
    setImageId(state, payload) {
      state.imageId = payload;
    },
    setShowLoadingBanner(state, payload) {
      state.showLoadingBanner = payload;
    },
    setImageIdBanner(state, payload) {
      state.imageIdBanner = payload;
    },
    setImageNonPremuimId(state, payload) {
      state.imageNonPremuimId = payload;
    },
    setImageNonPremuimIdBanner(state, payload) {
      state.imageNonPremuimIdBanner = payload;
    },
    setShowLoadingDark(state, payload) {
      state.showLoadingDark = payload;
    },
    setImageIdDark(state, payload) {
      state.imageIdDark = payload;
    },
    resetImageId(state) {
      state.imageId = null;
    }
  },
  actions: {
    resetImageId({ commit }) {
      commit('resetImageId');
    },
    async uploadImageNonPremuimSuccess({ commit }, { index, fileList }) {
      const imageName = fileList[index].name;

      const file = convertImagePathToFile(fileList[index]);
      const formDataToSend = new FormData();
      let positionPoint = fileList[index].name.lastIndexOf(".");
      let type = fileList[index].name.substring(positionPoint + 1);
      if (type != 'svg') {
        type = 'img'
      }
      formDataToSend.append("file", file, imageName);
      formDataToSend.append('type', type)

      try {
        commit('setShowLoadingBanner', true);
        const response = await fetch(`${Constant.QORANI}fileDB/upload`, {
          method: "POST",
          body: formDataToSend,
        });
        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error uploading imageBanner", response.status, "Response text:", errorText);
          commit('setShowLoadingBanner', false);
          return;
        }
        const responseData = await response.json();
        commit('setImageNonPremuimId', responseData.id);
        commit('setShowLoading', false);
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        commit('setShowLoadingBanner', false);
      }
    },
    async uploadImageSuccessNonPremuimBanner({ commit }, { index, fileList }) {
      const imageName = fileList[index].name;

      const file = convertImagePathToFile(fileList[index]);
      const formDataToSend = new FormData();
      let positionPoint = fileList[index].name.lastIndexOf(".");
      let type = fileList[index].name.substring(positionPoint + 1);
      if (type != 'svg') {
        type = 'img'
      }
      formDataToSend.append("file", file, imageName);
      formDataToSend.append('type', type)

      try {
        commit('setShowLoadingBanner', true);
        const response = await fetch(`${Constant.QORANI}fileDB/upload`, {
          method: "POST",
          body: formDataToSend,
        });
        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error uploading imageBanner", response.status, "Response text:", errorText);
          commit('setShowLoadingBanner', false);
          return;
        }
        const responseData = await response.json();
        commit('setImageNonPremuimIdBanner', responseData.id);
        commit('setShowLoadingBanner', false);
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        commit('setShowLoadingBanner', false);
      }
    },
    async uploadImageSuccess({ commit }, { index, fileList }) {
      const imageName = fileList[index].name;

      const file = convertImagePathToFile(fileList[index]);
      const formDataToSend = new FormData();
      console.log(fileList[index]);
      let positionPoint = fileList[index].name.lastIndexOf(".");
      let type = fileList[index].name.substring(positionPoint + 1);
      if (type != 'svg') {
        type = 'img'
      }
      formDataToSend.append("file", file, imageName);
      formDataToSend.append('type', type)
      console.log(type);

      try {
        commit('setShowLoading', true);

        const response = await fetch(`${Constant.QORANI}fileDB/upload`, {
          method: "POST",
          body: formDataToSend,
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error uploading image", response.status, "Response text:", errorText);
          commit('setShowLoading', false);
          return;
        }

        const responseData = await response.json();
        commit('setImageId', responseData.id);
        console.log("idImage store :", responseData.id);
        console.log("Image uploaded successfully:", responseData.message);
        commit('setShowLoading', false);
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        commit('setShowLoading', false);
      }
    },
    async uploadImageSuccessBanner({ commit }, { index, fileList }) {
      const imageName = fileList[index].name;

      const file = convertImagePathToFile(fileList[index]);
      const formDataToSend = new FormData();
      let positionPoint = fileList[index].name.lastIndexOf(".");
      let type = fileList[index].name.substring(positionPoint + 1);
      if (type != 'svg') {
        type = 'img'
      }
      formDataToSend.append("file", file, imageName);
      formDataToSend.append('type', type)

      try {
        commit('setShowLoadingBanner', true);

        const response = await fetch(`${Constant.QORANI}fileDB/upload`, {
          method: "POST",
          body: formDataToSend,
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error uploading imageBanner", response.status, "Response text:", errorText);
          commit('setShowLoadingBanner', false);
          return;
        }

        const responseData = await response.json();
        commit('setImageIdBanner', responseData.id);
        console.log("idImageBanner store:", responseData.id);
        console.log("ImageBanner uploaded successfully:", responseData.message);
        commit('setShowLoadingBanner', false);
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        commit('setShowLoadingBanner', false);
      }
    },
    async uploadImageSuccessDark({ commit }, { index, fileList }) {
      const imageName = fileList[index].name;

      const file = convertImagePathToFile(fileList[index]);
      const formDataToSend = new FormData();
      let positionPoint = fileList[index].name.lastIndexOf(".");
      let type = fileList[index].name.substring(positionPoint + 1);
      if (type != 'svg') {
        type = 'img'
      }
      formDataToSend.append("file", file, imageName);
      formDataToSend.append('type', type)

      try {
        commit('setShowLoadingDark', true);

        const response = await fetch(`${Constant.QORANI}fileDB/upload`, {
          method: "POST",
          body: formDataToSend,
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error uploading imageDark", response.status, "Response text:", errorText);
          commit('setShowLoadingDark', false);
          return;
        }

        const responseData = await response.json();
        commit('setImageIdDark', responseData.id);
        console.log("idImageDark store:", responseData.id);
        console.log("ImageDark uploaded successfully:", responseData.message);
        commit('setShowLoadingDark', false);
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        commit('setShowLoadingDark', false);
      }
    },
  },

});

function convertImagePathToFile(element) {
  const byteString = atob(element.path.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ia], { type: "image/jpeg" });
  return new File([blob], element.name);
}


export default store;
